"use client";

import { useLayoutEffect } from "react";
import { gsap, ScrollTrigger, SplitText, gsapUtils } from "../../lib/gsap";
import { usePathname } from "next/navigation";

export default function RevealOnScroll() {
  // All animations disabled - just show everything immediately
  return null;
}
